export enum PetitionTypes {
    unspecified,
    absence,
    extraHours,
    hourCompensation
  }


// WEBPACK FOOTER //
// ./src/models/petition-types.ts